import { RootState } from '../../../store/index';
import { useSelector } from 'react-redux';
import { TransFilterState } from './innerState';

export const useGetTransactionTableState = (): TransFilterState =>
  useSelector((state: RootState) => {
    return state.TransactionFilter;
  });
